'use client';
import React, { useRef } from 'react';
import Slider from 'react-slick';
import LazyLoadImage from '@repo/ui/src/components/LazyLoadImage';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import { ImageProps } from '@repo/ui/src/types';
import { LeftArrow, RightArrow } from './CarouselArrows';

interface Props {
  asset: { image?: ImageProps }[];
  order: number;
  testID?: string;
}

const ImageSlide = (props: { image?: ImageProps }) => {
  const { image } = props;
  const imgUrl = image ? buildImageSrc(image, 700, 4, 3) : null;
  return (
    <div className="mx-2 d-flex justify-content-center img-container mx-md-3">
      {imgUrl ? (
        <LazyLoadImage
          imgComponent={
            <img
              className="rounded w-full max-w-full max-h-[185px] sm:max-h-[240px] md:max-h-full"
              src={imgUrl}
            />
          }
        />
      ) : null}
    </div>
  );
};

const FullWidthAssetCarousel = ({ asset, order, testID }: Props) => {
  const sliderRef = useRef<Slider>(null);

  const next = () => {
    sliderRef.current?.slickNext();
  };

  const previous = () => {
    sliderRef.current?.slickPrev();
  };

  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
  };

  return (
    <div
      className="py-5 row jumbotron d-flex white-background justify-content-center overflow-hidden relative"
      style={{ zIndex: order, width: '100%', margin: 0 }}
      data-test-id={`full_width_asset_carousel_${testID}`}
    >
      <div className="mr-3 absolute top-1/2 left-[4%] translate-y-1/2 z-[1000]" onClick={previous}>
        <LeftArrow />
      </div>
      <div className="ml-4 absolute top-1/2 right-[4%] translate-y-1/2 z-[1000]" onClick={next}>
        <RightArrow />
      </div>
      <div className="full-carousel-overflow">
        <Slider ref={sliderRef} {...settings}>
          {asset.map((item, i: number) => (
            <ImageSlide {...item} key={i} />
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default FullWidthAssetCarousel;
